// utils/fieldWidth.ts

/**
 * Span for a field card in a 12-column grid, based purely on row occupancy.
 * 1 field -> full width (12). 2 fields -> half width each (6).
 * >2 is invalid and is rejected by validation before it can ever reach here.
 */
export function columnSpan(rowFieldCount: number): number {
  if (rowFieldCount <= 1) return 12;
  return 6;
}